import { styled } from '@openeducation/oe-it-themes';
import React, { memo } from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';

import { TestId } from '../../constants/test-id';
import { flex } from '../../style-utils';

export interface ArrowDividerProps {
  color?: string;
  style?: StyleProp<ViewStyle>;
  triangleBackground?: string;
}

export const DEFAULT_DIVIDER_COLOR = '#DDEEFE';

const ArrowDivider = ({
  color = DEFAULT_DIVIDER_COLOR,
  style,
  triangleBackground,
}: ArrowDividerProps) => {
  return (
    <View style={[flex('flex-row'), style]}>
      <Line color={color} testID={TestId.ARROW_DIVIDER_LINE} />
      <Triangle color={color} triangleBackground={triangleBackground} />
      <Line color={color} />
    </View>
  );
};

type CommonStyledTypes = {
  color?: string;
};

const DIVIDER_SIZE = 1;

const Line = styled.View<CommonStyledTypes>`
  height: ${DIVIDER_SIZE}px;
  flex: 1;
  background-color: ${({ color }) => color};
`;

type TriangleTypes = {
  triangleBackground?: string;
} & CommonStyledTypes;

const Triangle = styled.View<TriangleTypes>`
  width: 20px;
  height: 20px;
  border-right-color: ${({ color }) => color};
  border-right-width: ${DIVIDER_SIZE}px;
  border-bottom-color: ${({ color }) => color};
  border-bottom-width: ${DIVIDER_SIZE}px;
  transform: rotate(45deg);
  margin-top: -9px;
  background-color: ${({ theme, triangleBackground }) =>
    triangleBackground || theme.color.white};
  z-index: 2;
`;

export default memo(ArrowDivider);
